export const LOGIN_COUNTRIES = ['EG', 'SA', 'AE'] as const

export type LoginCountry = (typeof LOGIN_COUNTRIES)[number]

export const DIAL_CODES: Record<LoginCountry, string> = {
  EG: '+20',
  SA: '+966',
  AE: '+971',
}

export function looksLikeEmail(value: string): boolean {
  return value.trim().includes('@')
}

/**
 * A phone as the person types it: a digit or "+" first, then only digits,
 * spaces, brackets and dashes. The screen shows the country picker for this
 * only; anything else is still being typed as an email.
 */
export function looksLikePhone(value: string): boolean {
  return /^[+\d][\d\s()-]*$/.test(value.trim())
}

export function isInternational(value: string): boolean {
  const trimmed = value.trim()
  return trimmed.startsWith('+') || trimmed.startsWith('00')
}
